import { useQuery } from '@tanstack/react-query'

import { Skeleton } from '@/components/skeleton/skeleton'

import { getPricingQuery } from '@/lib/queries/business/pricing/queries'
import { getUserQuery } from '@/lib/queries/business/v2/user/queries'

import { EnterprisePlan } from './ui/pricing-enterprise-plan'
import { PricingHeader } from './ui/pricing-header'
import { PricingPlans } from './ui/pricing-plans'

export const PricingPage = () => {
  const { data: dataUser } = useQuery(getUserQuery)
  const { data: dataPricing, isPending: isDataPricingPending } = useQuery(getPricingQuery)
  return (
    <>
      <div className="min-h-full bg-[#000228] bg-[linear-gradient(180deg,_#250028_0%,_#000448_100%)]">
        <PricingHeader />

        {isDataPricingPending || !dataUser ? (
          <div className="flex justify-center gap-8 px-5 opacity-10">
            <Skeleton className="h-[500px] max-w-[333px] flex-1 rounded-2xl" />
            <Skeleton className="h-[500px] max-w-[333px] flex-1 rounded-2xl" />
            <Skeleton className="h-[500px] max-w-[333px] flex-1 rounded-2xl" />
          </div>
        ) : (
          <>
            <PricingPlans pricing={dataPricing} user={dataUser} />
            <EnterprisePlan pricing={dataPricing} />
          </>
        )}
      </div>
    </>
  )
}
